import {EditService} from "../../../../framework/entity/edit/edit-page/edit.service";
import {Component} from "@angular/core";
import {ReportModel} from "@fedeltapointofsale/data-client";


@Component({
    selector: "wbo-best-worst-sellers-report-criteria",
    templateUrl: "./best-worst-sellers-report-criteria.component.html"
})
export class BestWorstSellersReportCriteriaComponent {
    constructor(public model: ReportModel<any>, public editService: EditService) {
    }
}
